module.exports = __webpack_public_path__ + "static/media/play_arrow_white.b02c4fb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/play_arrow_white.svg
// module id = 833
// module chunks = 0